import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
interface PricingItem {
  service: string;
  duration: string;
  fee: string;
}
const pricingPlans: PricingItem[] = [{
  service: "Initial Physiotherapy Consultation & Treatment",
  duration: "60 minutes",
  fee: "£80"
}, {
  service: "Follow-Up Physiotherapy",
  duration: "30 minutes",
  fee: "£60"
}, {
  service: "Extended Follow-Up Physiotherapy",
  duration: "60 minutes",
  fee: "£80"
}];
export default function PhysiotherapyPricing() {
  return <section id="stalbansphysiotherapypricing" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        {/* Header Block */}
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-14">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-default mb-6">
            Physiotherapy in St Albans
          </h2>
          <div className="space-y-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            <p>
              Physiotherapy is the best starting point for a new injury, persistent pain, or post-operative rehabilitation. Our expert clinicians focus on accurate biomechanical assessment, hands-on treatment, and guided exercise therapy to relieve pain and restore natural movement.
            </p>
            <p>
              Whether you are managing joint stiffness, back pain, or training setbacks, each session is tailored to your specific recovery goals with clear timelines and progress tracking.
            </p>
          </div>
        </div>

        {/* Pricing Card & Table */}
        <div className="dark">
          <Card className="bg-card text-card-foreground border-border/40 shadow-xl rounded-2xl overflow-hidden py-0">
            <CardContent className="p-0">
              <Table>
                <TableHeader>
                  <TableRow className="border-border/30 hover:bg-transparent">
                    <TableHead className="text-card-foreground/70 font-semibold py-4 px-6 sm:px-8 text-sm sm:text-base">
                      Service
                    </TableHead>
                    <TableHead className="text-card-foreground/70 font-semibold py-4 px-4 sm:px-6 text-sm sm:text-base">
                      Duration
                    </TableHead>
                    <TableHead className="text-card-foreground/70 font-semibold py-4 px-6 sm:px-8 text-right text-sm sm:text-base">
                      Fee
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {pricingPlans.map((item, i) => <TableRow key={item.service} data-index={i} className="border-border/20 transition-colors hover:bg-accent/40">
                      <TableCell className="font-medium text-card-foreground py-5 px-6 sm:px-8 text-sm sm:text-base whitespace-normal">
                        {item.service}
                      </TableCell>
                      <TableCell className="text-card-foreground/80 py-5 px-4 sm:px-6 text-sm sm:text-base whitespace-nowrap">
                        {item.duration}
                      </TableCell>
                      <TableCell className="text-right font-semibold text-card-foreground py-5 px-6 sm:px-8 text-base sm:text-lg whitespace-nowrap">
                        {item.fee}
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </div>

        {/* Footer Note & Call to Action */}
        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-between gap-5 text-center sm:text-left">
          <p className="text-sm text-muted-foreground">
            Appointments available for new and returning patients.
          </p>
          <Button asChild size="lg" className="w-full sm:w-auto font-medium">
            <Link to="https://physiogenics.uk3.cliniko.com/bookings?business_id=1933385715966552600" newTab>
              Book Physiotherapy
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}